import liff from '@line/liff';
import axios from 'axios';

export async function loadLiff(dispatch, csrf_token, page_type, funnel_page_id, member_connect_id, sl, preview) {
	let liff_data;

	switch (page_type) {
		case 'funnel':
			liff_data = await getLiffDataFromFunnelPageId(funnel_page_id);
			break;

		case 'member_connect':
			break;
	}

	const {runtime_medium, liff_id, line_friend_only, need_login, controller} = liff_data;

	console.log(`sl`, sl, `liff_id`, liff_id, `runtime_medium`, runtime_medium, `line_friend_only`, line_friend_only);
	//console.log(login_methods.indexOf('no_login'));

	if (sl === '0' && runtime_medium === 'line_app' && liff_id !== '' && !preview) {
		try {
			await liff.init({
				liffId: liff_id,
				withLoginOnExternalBrowser: true
			});

			const profile = await liff.getProfile();
			//alert(JSON.stringify(profile));
			const user_id = profile.userId;
			const name = profile.displayName;
			//console.log(`name: ${name}`);

			const user = liff.getDecodedIDToken();
			//alert(JSON.stringify(user));
			const email = user.email;

			var line_profile_data = {
				line_user_id: user_id,
				name: name,
				email: email
			}

			const member_level_granted = await checkMemberLevelGranted(csrf_token, controller, funnel_page_id, member_connect_id, user_id);

			if (member_level_granted.rc) {
				fillLineData(line_profile_data, dispatch);

				liff.getFriendship().then((friend_data) => {
					if (friend_data.friendFlag) {
						console.log("is line friend");
						$(".membership").addClass('d-none');
						$("#line-follow").val(1);
					} else {
						console.log("not line friendship");
						if (line_friend_only == 1) {
							redirectError();
						}
					}

					if (typeof redirectAfterLogin == 'function') {
						redirectAfterLogin(member_level_granted);
					}
				});
			} else if (need_login) {
				redirectNoPermission();
			}
		} catch (err) {
			// 發生錯誤
			console.log("error");
			console.log(err.code);
			console.log(err.message);

			localStorage.clear();
			location.reload();
		}
	} else if (need_login) {
		const member_level_granted = await checkMemberLevelGranted(csrf_token, controller, funnel_page_id, member_connect_id);

		if (!member_level_granted.rc) {
			redirectNoPermission();
		} else if (typeof redirectAfterLogin == 'function') {
			redirectAfterLogin(member_level_granted);
		}
	}
}

async function getLiffDataFromFunnelPageId(funnel_page_id) {
	try {
		const response = await axios.get(`/FunnelPages/ajaxGetLiffData/${funnel_page_id}`);

		return response.data;
	} catch (e) {
		console.error(e);
	}
}

function fillLineData(line_profile_data, dispatch) {
	dispatch({
		type: 'SET_LINE_USER_DATA',
		payload: {
			field: 'userId',
			value: line_profile_data.line_user_id
		}
	});

	dispatch({
		type: 'SET_LINE_USER_DATA',
		payload: {
			field: 'nickname',
			value: line_profile_data.name
		}
	});

	dispatch({
		type: 'SET_LINE_USER_DATA',
		payload: {
			field: 'email',
			value: line_profile_data.email
		}
	});

	// $("#line-user-id").val(line_profile_data.line_user_id);
	// $("#name, #line-nickname").val(line_profile_data.name);
	// $("#email, #line-email").val(line_profile_data.email);
}

function redirectError(page_type, funnel_page_id, member_connect_id) {
	switch (page_type) {
		case 'funnel':
			location.href = `/Membership/error/${funnel_page_id}`;
			break;
	}
}

function redirectNoPermission(page_type, funnel_page_id, member_connect_id) {
	switch (page_type) {
		case 'funnel':
			location.href = `/Membership/no_permission/funnel_page/${funnel_page_id}`;
			break;

		case 'member_connect':
			location.href = `/Membership/no_permission/member_connect/${member_connect_id}`;
			break;
	}
}

async function checkMemberLevelGranted(csrf_token, controller, funnel_page_id, member_connect_id, user_id) {
	try {
		const response = await axios.post('/FunnelPages/ajaxCheckMbrLevelGranted', {
			_csrfToken: csrf_token,
			page_controller: controller,
			line_user_id: user_id,
			funnel_page_id: funnel_page_id,
			member_connect_id: member_connect_id
		});
		return response.data;
	} catch (error) {
		console.error(error);
	}
}